import styled, { css } from 'styled-components';
import { Link } from 'gatsby';

export const BigText = styled.span``;

interface IBigTagContainer {
  $active?: boolean;
  $fixedTagBox?: boolean;
  $fixedTime?: number;
  $isFixed?: boolean;
}

const BigTagContainerStyle = css<IBigTagContainer>`
  padding: 0 15px;
  background-color: ${(props) =>
    props.$active ? props.theme.colors.black : 'transparent'};
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  transition: background-color 0.4s ease;
  position: relative;

  background-size: 100%;
  background-image: linear-gradient(90deg, transparent 0%, transparent 100%);

  &:before {
    content: '';
    border-radius: 8px;
    background-image: linear-gradient(90deg, #fffeff 0%, #d7fffe 100%);
    display: block;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: -1;
    transition: opacity 0.4s ease;
  }

  & ${BigText} {
    font-size: 14px;
    line-height: 100%;
    font-weight: 700;
    color: ${(props) =>
      props.$active ? props.theme.colors.white : props.theme.colors.black};
  }

  ${(props: IBigTagContainer) => {
    if (props.$fixedTagBox) {
      return `
      transition: opacity ${props.$fixedTime}s ease, transform ${
        props.$fixedTime
      }s ease, background-color 0.4s ease;
      opacity: ${props.$isFixed ? '1' : '0'};
      transform: ${props.$isFixed ? 'translate(0, 0)' : 'translate(-20px, 0)'};
      `;
    }
  }}

  &:hover {
    ${(props) =>
      !props.$active &&
      props.$fixedTagBox &&
      `background-color: ${props.theme.colors.hoverWhite};`}
    &::before {
      ${(props) =>
        !props.$active &&
        !props.$fixedTagBox &&
        `
          opacity: 1;
        `}
    }
  }
`;

export const BigTagContainer = styled(Link)<IBigTagContainer>`
  ${BigTagContainerStyle}
`;

export const SmallText = styled.span`
  font-size: 14px;
  line-height: 100%;
  font-weight: ${(props) => props.theme.weights.regular};
`;

interface ISmallTagContainer {
  $isBlogArticleCard?: boolean;
}

export const SmallTagContainerStyle = css<ISmallTagContainer>`
  padding: ${(props: ISmallTagContainer) =>
    props.$isBlogArticleCard ? '0 10px' : '0 15px'};
  height: ${(props: ISmallTagContainer) =>
    props.$isBlogArticleCard ? '30px' : '36px'};
  border-radius: 100px;
  cursor: pointer;
  white-space: nowrap;
  background-color: ${(props) => props.theme.colors.hoverWhite};
  display: flex;
  align-items: center;
  transition: background-color 0.4s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.tagBgGray};
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    padding: ${(props: ISmallTagContainer) =>
      props.$isBlogArticleCard ? '0 10px' : '0 12px'};
  }
`;

export const SmallTagContainer = styled(Link)<ISmallTagContainer>`
  ${SmallTagContainerStyle}
`;

type IDropdownTagContainer = IBigTagContainer;

export const DrowdownTagContainer = styled.div<IDropdownTagContainer>`
  ${BigTagContainerStyle}
  ${BigTagContainer} {
    &::before {
      display: none;
    }
    &:hover {
      ${(props) =>
        !props.$active && `background-color: ${props.theme.colors.hoverWhite};`}
    }
  }
  position: relative;
`;

interface IOpen {
  open?: boolean;
}

interface IDrowdownRestTags extends IOpen {
  length: number;
  $isFixed: boolean;
  left: number;
  $mobileCenter: number;
}

export const DrowdownRestTags = styled.div<IDrowdownRestTags>`
  position: absolute;
  top: 60px;
  left: ${(props: IDrowdownRestTags) => `${props.left}px`};
  transition: ${(props) => props.theme.transition.primary};
  min-width: 175px;
  height: ${(props: IDrowdownRestTags) =>
    props.open
      ? `calc(30px + 36*${props.length}px + 20*${props.length - 1}px)`
      : '0px'};
  z-index: 1;
  pointer-events: ${(props: IOpen) => (props.open ? 'auto' : 'none')};
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 20px;
    background: rgba(255, 255, 255, 1);
    border: 1.5px solid ${(props) => props.theme.colors.lightGray2};
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    left: ${(props: IDrowdownRestTags) => `${props.$mobileCenter}px`};
  }
`;

export const DrowdownList = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  padding: 15px;
  cursor: auto;
`;

export const DrowdownListItem = styled.li`
  ${BigTagContainer} {
    &:hover {
      background-color: ${(props) => props.theme.colors.hoverWhite};
    }
  }
  ${BigText} {
    color: ${(props) => props.theme.colors.black};
  }
`;
